import { render, staticRenderFns } from "./ContentSidebar.vue?vue&type=template&id=4aa4ac90&"
import script from "./ContentSidebar.vue?vue&type=script&lang=js&"
export * from "./ContentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports